import './styles/styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ClassicEdxCoursePropTypes from '@prospectus/common/types/classicEdxCoursePropTypes';
import ClassicEdxProgramPropTypes from '@prospectus/common/types/classicEdxProgramPropTypes';
import ProductPropTypes from '@prospectus/common/types/productPropTypes';
import CardContainer from '@prospectus/common/ui/CardContainer';
import useSearchParams from '@prospectus/common/hooks/useSearchParams';
import useBreakpointMatch from '@prospectus/common/hooks/useBreakpointMatch';

import { QUIZ_MATCH_PARAM } from '@utils/search';
import CurrentRefinements from '../../../search-page/components/RefinementFilters/components/CurrentRefinements';

function RecommendationsContainer({
  recommendations,
  mainHeading,
  subHeading,
  alignHeading,
  analytics,
  displayAsResultList,
  additionalHeadingClasses,
  maxRecommendations,
  isScrollable,
  isLoading,
}) {
  const { getRefinements, searchParams } = useSearchParams();
  const isMobile = useBreakpointMatch('medium');

  return (
    <>
      {mainHeading && (
        displayAsResultList ? (
          <h2
            className={classNames(
              `text-${alignHeading} h2 d-inline-block ${additionalHeadingClasses}`,
              { 'section-heading skeleton skeleton-pulse mr-3': isLoading },
              { 'mb-4 mb-sm-4.5': isMobile },

            )}
          >
            {!isLoading && mainHeading}
          </h2>
        ) : (
          <h1
            className={classNames(
              `text-${alignHeading} mb-4.5 mb-sm-5 ${additionalHeadingClasses}`,
              { 'section-heading skeleton skeleton-pulse mr-3': isLoading },
              { 'mt-4 mt-sm-4.5': isMobile },
            )}
          >
            {!isLoading && mainHeading}
          </h1>
        )
      )}
      {subHeading && (
        <p
          className={classNames(
            'text-left mb-3',
            { 'section-heading skeleton skeleton-pulse mr-3': isLoading },
          )}
        >
          {!isLoading && subHeading}
        </p>
      )}
      {!isMobile && searchParams.has(QUIZ_MATCH_PARAM)
            && (
            <div className="mb-3.5 mb-md-4">
              <CurrentRefinements refinements={getRefinements()} isMobile={isMobile} />
            </div>
            )}
      <CardContainer
        productList={recommendations.slice(0, maxRecommendations)}
        isScrollable={isScrollable}
        searchProps={{
          analytics,
          isLoading,
        }}
        additionalClassNames={classNames('mt-4', { 'mb-4': !isMobile })}
        cardsPerRow={!isMobile ? 3 : 4}
      />
    </>
  );
}

RecommendationsContainer.propTypes = {
  alignHeading: PropTypes.oneOf(['left', 'center', 'right']),
  analytics: PropTypes.shape({
    is_control: PropTypes.bool,
    variation: PropTypes.string,
    page: PropTypes.string,
  }),
  displayAsResultList: PropTypes.bool,
  mainHeading: PropTypes.element,
  subHeading: PropTypes.element,
  recommendations: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape(ClassicEdxCoursePropTypes.course),
      PropTypes.shape(ClassicEdxProgramPropTypes.program),
      PropTypes.shape(ProductPropTypes),
    ]),
  ).isRequired,
  additionalHeadingClasses: PropTypes.string,
  maxRecommendations: PropTypes.number,
  isScrollable: PropTypes.bool,
  isLoading: PropTypes.bool,
};

RecommendationsContainer.defaultProps = {
  alignHeading: 'left',
  analytics: {},
  displayAsResultList: false,
  mainHeading: '',
  subHeading: '',
  additionalHeadingClasses: '',
  maxRecommendations: 4,
  isScrollable: true,
  isLoading: false,
};

export default RecommendationsContainer;
